import { useAppDispatch } from "../../../hooks/StoreHooks";
import { FC } from "react";
import { useTranslation } from "react-i18next";
import { SearchWithAutocompleteWrapper } from "../../../components/common/SearchWithAutocomplete/SearchWithAutocomplete.styles";
import { editCertificatesThunk } from "../../../store/thunk/certificatesThunk";
import { setCreateMode, setEditMode, setProcessingRequest, setResponseMessage, setResponseValue } from "../../../store/reducers/tableManagementReducer";
import ServerSideSearchBar from "../../../components/common/table/ServerSideSearchBar";
import { useCreateMode, useEditMode } from "../../../store/selectors/tableManagementSelector";
import SearchBarButtonContainer from "../../../components/common/table/SearchBarButtonContainer";
import { mapThunkTypeToResponseValue } from "../../../common/logic/mapThunkTypeToResponseValue";

interface CertificatesSearchBarProps {
  onSearchHandler: (searchQuery: string) => void;
}

const CertificatesSearchBar: FC<CertificatesSearchBarProps> = ({ onSearchHandler }) => {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  const editMode = useEditMode();
  const createMode = useCreateMode()

  const handleOnCreateCertificate = () => {
    dispatch(setCreateMode(!createMode));
  };

  const handleOnEditCertificate = () => {
    dispatch(setEditMode(true));
  };

  const handleOnSave = async () => {
    dispatch(setProcessingRequest(true))
    let res = await dispatch(editCertificatesThunk());
    dispatch(setResponseValue(mapThunkTypeToResponseValue(res.type)));
    dispatch(setResponseMessage(`${t("dialogModals.itemsSaved")}`))
  };

  return (
    <SearchWithAutocompleteWrapper>
      <ServerSideSearchBar
        onSearchHandler={onSearchHandler}
      />
      <SearchBarButtonContainer
        onCreateClick={editMode ? undefined : handleOnCreateCertificate}
        onEditClick={createMode || editMode ? undefined : handleOnEditCertificate}
        onSaveClick={editMode ? handleOnSave : undefined}
        createMode={createMode}
      />
    </SearchWithAutocompleteWrapper>
  );
};

export default CertificatesSearchBar;
